export const authModel = {
  login: {
    imgSrc: '/assets/saCentre.png',
    header: 'Version: 3.0.4',
    subHeader: '',
    emailFieldLabel: 'Email',
    passwordFieldLabel: 'Password',
    btnLoginText: 'Login',
    forgotPasswordLinkTxt: 'Forgot Password ?',
    width: '340px',
    isEmailLogin: false,
  },
  forgotPassword: {
    header: 'Forgot Password',
    subHeader: 'Please provide details below',
    emailFieldLabel: 'Email',
    btnContinueText: 'Continue',
    btnCancelText: 'Cancel',
    width: '360px',
  },
  forgotPasswordForm: {
    header: 'Forgot Password',
    subHeader: 'Please provide details below',
    codeFieldLabel: 'Verification Code',
    passwordFieldLabel: 'Password',
    confirmPasswordFieldLabel: 'Confirm Password',
    btnContinueText: 'Continue',
    btnCancelText: 'Cancel',
    width: '100%',
  },
  verifyEmail: {
    header: 'Verify Email',
    subHeader: 'Please provide code emailed',
    emailFieldLabel: 'Email',
    codeFieldLabel: 'Verification Code',
    btnContinueText: 'Continue',
    btnCancelText: 'Cancel',
    width: '100%',
  },
  passwordResetRequired: {
    header: 'Reset Password Required',
    subHeader: '',
    emailFieldLabel: 'Email',
    codeFieldLabel: 'Verification Code',
    tempPasswordFieldLabel: 'Password',
    passwordFieldLabel: 'New Password',
    confirmPasswordFieldLabel: 'Confirm Password',
    btnContinueText: 'Continue',
    btnCancelText: 'CANCEL',
    width: '340px',
  },
};
